import React from "react";
import {
  ShimmerTable,
  ShimmerButton,
  ShimmerTitle,
  ShimmerText,
  ShimmerThumbnail,
} from "react-shimmer-effects";

const FirstLastTouchLoading2 = () => {
  return (
    <div className="p-2 bg-gray-100 ">
      <div className="bg-white p-4 shadow rounded-lg mb-1">
        <ShimmerTable row={3} col={4} />
      </div>
    </div>
  );
};

export default FirstLastTouchLoading2;
